export const vinologix_support = "support@vinologix.com";
export const sendingwines_support = "support@sendingwines.be";